import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IdmsSubHeaderComponent } from '../idms-sub-header/idms-sub-header.component';
import { TaggedItemCreateComponent } from '../plant-manager/components/tagged-item-create/tagged-item-create.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AddNewProjectsComponent } from '../project-manager/components/add-new-projects/add-new-projects.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
    declarations: [IdmsSubHeaderComponent, TaggedItemCreateComponent, AddNewProjectsComponent],
    imports: [CommonModule, RouterModule, NgbModule, TranslocoModule],
    exports: [IdmsSubHeaderComponent, TaggedItemCreateComponent, AddNewProjectsComponent],
})
export class IdmsHeadersModule {}
